// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4g-2";
export var blackBorderOnHover = "_4g-7";
export var cell = "_4g-6";
export var cellContainer = "_4g-3";
export var checked = "_4g-8";
export var disabled = "_4g-5";
export var featuredIconCellContainer = "_4g-9";
export var featuredIconTextContainer = "_4g-b";
export var featuredIconWrapper = "_4g-a";
export var noBorder = "_4g-c";
export var orangeSelectedRow = "_cb-3";
export var overflowableText = "_4g-0";
export var overflowableTextContainer = "_4g-1";
export var row = "_4i-0";
export var rowCheckboxCell = "_4g-4";
export var selectableTable = "_cb-2";